<template>
  <div class="">
    <salesmen-edit> </salesmen-edit>
  </div>
</template>

<script>
import SalesmenEdit from "@/components/profile/brokers/agency-brokers/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    SalesmenEdit,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Produttori di Agenzia",
        path: "module.PROF.PRCO",
        tab: "#AgencyBrokers",
        level: 3,
      });
      bcs.push({
        text: "Modifica Produttore di Agenzia",
        path: "brokers.edit2",
        level: 4,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Produttori di Agenzia",
        path: "module.PROF.PRCO",
        tab: "#AgencyBrokers",
        level: 3,
      });
      this.notifyQueue({
        text: "Modifica Produttore di Agenzia",
        path: "brokers.edit2",
        level: 4,
      });
    }
  },
};
</script>
